import {Component, OnInit, Input} from '@angular/core';

@Component({
  selector: 'app-account-subtotal-select',
  templateUrl: './account-subtotal-select.component.html',
  styleUrls: ['./account-subtotal-select.component.css'],
  standalone: false
})
export class AccountSubtotalSelectComponent implements OnInit {
  @Input() vm: any;

  constructor() {
  }

  ngOnInit() {
  }

}
